declare var YT:any;

import { h, Component } from 'preact'
import '../styles/youtubePopup.scss';


//init youtube api
const tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let player = null;

export default class youtubePopup extends Component<any, any> {
  
  constructor() {
    super();
  }
  
  componentDidMount() {
    player = new YT.Player('playerYo', {
      height: '360',
      width: '640',
      videoId: this.props.data
    });
  }
  
  private close = (e) => {
    if (e.target.className.indexOf('close') != -1) {
      player.stopVideo();
      this.props.cb();
    }
  };
  
  public render (props, state): any {
    return <div id="youtubePopup" class="close" onClick={ this.close }>
      <button class="closePopup close animated fadeInDown"><i class="close fa fa-times">&nbsp;</i></button>
      <div id="playerYo" class="animated fadeInUp">&nbsp;</div>
    </div>;
  }
  
};


// WEBPACK FOOTER //
// ./ts/youtubePopup.tsx